module.exports = __webpack_public_path__ + "media/images/common/ico-cart-w-f6bf98d211d32907fa33decc2fe26438.svg";